"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.daysLeftLabel = daysLeftLabel;
/**
 * The pay-period countdown, in words (DASH-S09).
 *
 * `days_left` counts the days still to come AFTER today, so the period's last
 * day is 0. Rendered as `{n} days left` it read "1 days left" and, on the last
 * day, "0 days left", which sounds like the period is already over. The
 * record's expected strings: "1 day left" and "Last day".
 */
function daysLeftLabel(daysLeft) {
    if (daysLeft <= 0)
        return "Last day";
    if (daysLeft === 1)
        return "1 day left";
    return `${daysLeft} days left`;
}
//# sourceMappingURL=periodCopy.js.map